import { render, staticRenderFns } from "./BusinessVCR.vue?vue&type=template&id=691b2482&scoped=true&"
import script from "./BusinessVCR.vue?vue&type=script&lang=ts&"
export * from "./BusinessVCR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691b2482",
  null
  
)

export default component.exports